export default __webpack_public_path__ + "static/media/register-img.8094c37b.png";